module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc151366859"
    }
  }, [_vm._v("The Undulating Field")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_8"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("(")]), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("My response")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("A dull, dreary, and monotonous life, I never liked.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("The one I wished for was like an undulating field—challenging but victorious.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Always staying up but never looking down on anything, human or animal.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I had dreams, and their fulfilment was paramount to my being.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("What I had not bargained for was the world and its many faces.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I had not known then, that undulating fields hardly bear any yields.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I had not bargained on the constraints and limitations that the world grants.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("That the passage of life is controlled by time and waits for no one.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Making a living, family, friends, and all must fit within constricted boundaries.")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("A life like ‘an undulating field’ I achieved, but at the cost of my dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("That may be the case, but I stayed in touch, and my aspirations lingered on.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those traits once acquired, stay and never lose their taste nor flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("They did not fade away because all of it was inherent.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("A gift, a talent, a misdemeanour, an annoyance? I was once confused.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I was loved, adored, encouraged, motivated, and applauded because of it.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It also was the root of hatred and malice. I was bullied and jeered by some.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("But I was happiest then, with ‘my head in the clouds’, as my dad would say.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("No photo nor film could capture what his heart could discern and commit to memory.")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("That was then, before responsibilities and accountability came to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("There were family and friends and a living to earn and chores to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("But times go by, nights turn into days, seasons change; nothing stays the same.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Long-forgotten memories resurface, and so do hopes and dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Abandoned practices regain favour as priorities change, and new discoveries are made.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It’s surprising how ingrained traits spring into action once evoked.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("How wonder and mystery return as if they had never left.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("But the beauty of it all is that opportunities arise that make it possible for us to pursue the realisation of our dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b727e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_005.vue
// module id = 78
// module chunks = 0